import React from 'react';
import { Star } from 'lucide-react';
import { FormattedMessage } from 'react-intl';

import Button from '..';
import styles from './index.scss';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '~/services/axios';

export default function FeaturedButton({
  image
}: {
  image: GalleryImage
}) {
  const featured = !!image.featured_at;
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ value }: { value: boolean }) => axios.patch(`/gallery/${image.id}`, {
      featured: value,
    }).then(res => res.data),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: ['gallery'] });
    }
  });

  return (
    <Button onClick={() => mutation.mutate({ value: !featured })} disabled={mutation.isPending} className={styles.FeaturedButton} size="small" color="black">
      <Star size={14} fill={featured ? "#FFD700" : ""} color={featured ? "#FFD700" : undefined} />
      &nbsp;

      {
      featured ? (
        <FormattedMessage id="FeaturedButton_Featured" defaultMessage="Featured Image" />
      ) : (
        <FormattedMessage id="FeaturedButton_Feature" defaultMessage="Feature" />
      )
      }
    </Button>
  )
}